

















































































import {Vue, Component} from "vue-property-decorator";
import MyForm from "../MyForm";
import router from "../router";
import axios from "axios";


@Component({})
export default class Login extends Vue {

    public message = '';
    public success = false;
    public isBadCredentials = false;

    public form = new MyForm({
        email: "",
        password: "",
        password_confirmation: "",
        token: ''

    });


    reset() {

            axios.post("api/reset-password", this.form)
            .then(data => {
                this.form.reset();
                this.success = true
            })
            .catch(error => {
                if (error.response.data.code === 400) {
                    this.isBadCredentials = true;
                    this.message = error.response.data.message;
                }
                this.form.error = error.response.data.errors;
            });
    }

    goLogin(){
        router.replace({name: "Home"});
    }


}
